import { Injectable, inject } from "@angular/core";
import { Action } from "@ngrx/store";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { tap } from "rxjs/operators";

import {
  ActionScheduleSave,
  LocalStorageService,
  SCHEDULE_KEY,
  ScheduleActionTypes
} from "@app/core";

@Injectable()
export class ScheduleEffects {
  private actions$ = inject<Actions<Action>>(Actions);
  private localStorageService = inject(LocalStorageService);

  save$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ScheduleActionTypes.SAVE),
        tap((action: ActionScheduleSave) => {
          this.localStorageService.setItem(SCHEDULE_KEY, {
            startHour: (<any>action).payload.startHour,
            today: (<any>action).payload.today,
            numberOfHours: (<any>action).payload.numberOfHours,
            selectedDate: (<any>action).payload.selectedDate,
            layout: (<any>action).payload.layout,
            showMap: (<any>action).payload.showMap
          });
          // console.log(action);
        })
      ),
    { dispatch: false }
  );
}
